import { ListBox, type Selection } from "react-aria-components";

import { CustomListItem } from "../CustomListItem";

import type { ListColumn } from "./types";

export interface ListColumnProps {
  column: ListColumn;
  onSelect: (value: string) => void;
  selectedValue?: string;
}

export function ListColumn({ column, onSelect, selectedValue }: ListColumnProps) {
  const handleSelectionChange = (selection: Selection) => {
    if (selection !== "all" && selection.size > 0) {
      const selectedKey = Array.from(selection)[0];
      if (typeof selectedKey === "string") {
        onSelect(selectedKey);
      }
    }
  };

  return (
    <ListBox
      aria-label={`${column.title} options`}
      onSelectionChange={handleSelectionChange}
      selectedKeys={selectedValue ? [selectedValue] : []}
      selectionMode="single"
    >
      {column.items.map((item) => (
        <CustomListItem
          allowWrap={Boolean(item.element)}
          id={item.id}
          key={item.id}
          textValue={item.name}
        >
          {item.element || item.name}
        </CustomListItem>
      ))}
    </ListBox>
  );
}
